import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface VatGstItem {
    id: number;
    taxPercentage: number;
    countryId: number;
    countryName: string;
    createdDateTime?: Date;
    updatedDateTime?: Date;
}

@Injectable({
    providedIn: 'root',
})
export class VatGstService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/vat-gst`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
     * Get all
     */
    public getAll(
        pageIndex?: number,
        pageSize?: number,
        searchValue?: string,
        countryId?: number | number[]
    ): Observable<{ data: VatGstItem[]; paginatorValue: { totalData: number; totalCount: number } }> {
        let params = new HttpParams();
        if (pageIndex !== undefined && pageIndex !== null) {
            params = params.set('pageIndex', (pageIndex + 1).toString()); // API might use 1-based indexing
        }
        if (pageSize !== undefined && pageSize !== null) {
            params = params.set('pageSize', pageSize.toString());
        }
        if (searchValue && searchValue.trim() !== '') {
            params = params.set('searchValue', searchValue.trim());
        }
        if (countryId !== undefined && countryId !== null) {
            if (Array.isArray(countryId)) {
                if (countryId.length > 0) {
                    params = params.set('countryIds', countryId.join(','));
                }
            } else {
                params = params.set('countryId', countryId.toString());
            }
        }
        return this.http
            .get<{ data: VatGstItem[]; paginatorValue: { totalData: number; totalCount: number } }>(`${this.URL_PATH}/getAll`, { params })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Create a new 
     */
    public create(taxPercentage: number, countryId: number): Observable<{ message: string; result: VatGstItem }> {
        return this.http
            .post<{ message: string; result: VatGstItem }>(`${this.URL_PATH}/create`, { taxPercentage, countryId })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Update an existing
     */
    public update(id: number, taxPercentage: number, countryId: number): Observable<{ message: string; result: VatGstItem }> {
        return this.http
            .put<{ message: string; result: VatGstItem }>(`${this.URL_PATH}/update/${id}`, { taxPercentage, countryId })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Delete a 
     */
    public delete(id: number): Observable<{ message: string }> {
        return this.http
            .delete<{ message: string }>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}
